import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefetchOrderDocumentsMutationVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OpsOrderFilter>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type RefetchOrderDocumentsMutation = { __typename?: 'Mutation', refetchOrderDocuments: { __typename?: 'RefetchOrderDocumentsResult', labels_url: string, delivery_note_url: string, has_errors: boolean, successful_order_ids: Array<string> } };


export const RefetchOrderDocumentsDocument = gql`
    mutation RefetchOrderDocuments($filter: OpsOrderFilter, $ids: [ID!]) {
  refetchOrderDocuments(filter: $filter, ids: $ids) {
    labels_url
    delivery_note_url
    has_errors
    successful_order_ids
  }
}
    `;
export type RefetchOrderDocumentsMutationFn = Apollo.MutationFunction<RefetchOrderDocumentsMutation, RefetchOrderDocumentsMutationVariables>;

/**
 * __useRefetchOrderDocumentsMutation__
 *
 * To run a mutation, you first call `useRefetchOrderDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchOrderDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchOrderDocumentsMutation, { data, loading, error }] = useRefetchOrderDocumentsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRefetchOrderDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<RefetchOrderDocumentsMutation, RefetchOrderDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchOrderDocumentsMutation, RefetchOrderDocumentsMutationVariables>(RefetchOrderDocumentsDocument, options);
      }
export type RefetchOrderDocumentsMutationHookResult = ReturnType<typeof useRefetchOrderDocumentsMutation>;
export type RefetchOrderDocumentsMutationResult = Apollo.MutationResult<RefetchOrderDocumentsMutation>;
export type RefetchOrderDocumentsMutationOptions = Apollo.BaseMutationOptions<RefetchOrderDocumentsMutation, RefetchOrderDocumentsMutationVariables>;